import React from 'react';

import Modal from 'components/Modal';

import CompleteMessage from './CompleteMessage';
import ForgottenPasswordResetForm from './ForgottenPasswordResetForm';

export default function ForgottenPasswordResetModalComponent(props) {
  const {
    isComplete,
    isOpen,
    message,
    onRequestClose,
    onSubmit,
  } = props;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      {isComplete ? <CompleteMessage message={message} /> : <ForgottenPasswordResetForm onSubmit={onSubmit} />}
    </Modal>
  );
}